(() => {
  const tabConfigs = [
    {
      type: 'specs',
      sectionSelector: '[id^="shopify-section"][id*="product-tabs-with-specs"]',
      wrapperSelector: '[id^="ProductSpecs--"]',
      navItemClass: '.tabs-with-specs__nav-item',
      navListSelector: '.tabs-with-specs__nav ul',
      tabClass: '.tab-block',
    },
    {
      type: 'faq',
      sectionSelector: '[id^="shopify-section"][id*="tabs-with-faq"]',
      wrapperSelector: '[id^="TabsWithFAQ--"]',
      navItemClass: '.tabs-with-faq__nav-item',
      navListSelector: '.tabs-with-faq__nav ul',
      tabClass: '.tab-block',
    },
    {
      type: 'table',
      sectionSelector: '[id^="shopify-section"][id*="tabs-with-table"]',
      wrapperSelector: '[id^="TabsWithTable--"]',
      navItemClass: '.tabs-with-table__nav-item',
      navListSelector: '.tabs-with-table__nav ul',
      tabClass: '.tab-block',
    },
    {
      type: 'columns',
      sectionSelector: '[id^="shopify-section"][id*="tabs-with-columns"]',
      wrapperSelector: '[id^="TabsWithColumns--"]',
      navItemClass: '.tabs-with-columns__nav-item',
      navListSelector: '.tabs-with-columns__nav ul',
      tabClass: '.tab-block',
    },
    {
      type: 'videos',
      sectionSelector: '[id^="shopify-section"][id*="tabs-with-videos"]',
      wrapperSelector: '[id^="TabsWithVideos--"]',
      navItemClass: '.tabs-with-videos__nav-item',
      navListSelector: '.tabs-with-videos__nav ul',
      tabClass: '.tab-block',
      initExtra: initTabSliders,
    },
  ];

  const activeTabs = new Map();

  function activateTab(tabs, navItems, sectionId, targetId, focusNav = false, extra = null) {
    tabs.forEach((tab) => {
      const isActive = tab.id === targetId;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      if (isActive && typeof extra === 'function') extra(tab);
    });

    let activeNav = null;
    navItems.forEach((item) => {
      const isActive = item.dataset.tab === targetId;
      item.classList.toggle('active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive) activeNav = item;
    });

    activeTabs.set(sectionId, targetId);
    if (focusNav && activeNav) activeNav.focus();
  }

  function buildNav(navList, tabs, className, dataAttr) {
    navList.innerHTML = '';
    tabs.forEach((tab, i) => {
      const title = tab.querySelector('[data-tab-title]')?.textContent?.trim() || `Tab ${i + 1}`;

      const li = document.createElement('li');
      li.className = className.replace('.', '');
      li.dataset.tab = tab.id;
      li.id = `tab-button-${tab.id}`;
      li.textContent = title;
      li.setAttribute('role', 'tab');
      li.setAttribute('aria-controls', tab.id);
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('tabindex', '-1');
      navList.appendChild(li);
    });
  }

  function wireNavEvents(navList, tabs, navItems, sectionId, extra, classSelector) {
    if (navList.dataset.bound === 'true') return;

    navList.addEventListener('click', (e) => {
      const target = e.target.closest(classSelector);
      if (!target) return;
      activateTab(tabs, navItems, sectionId, target.dataset.tab, false, extra);
    });

    navList.addEventListener('keydown', (e) => {
      const current = e.target.closest(classSelector);
      if (!current) return;
      const index = navItems.indexOf(current);
      if (index === -1) return;

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateTab(tabs, navItems, sectionId, current.dataset.tab, false, extra);
        return;
      }

      const lastIndex = navItems.length - 1;
      let nextIndex = index;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') nextIndex = index === lastIndex ? 0 : index + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') nextIndex = index === 0 ? lastIndex : index - 1;
      else if (e.key === 'Home') nextIndex = 0;
      else if (e.key === 'End') nextIndex = lastIndex;
      else return;

      e.preventDefault();
      const nextItem = navItems[nextIndex];
      activateTab(tabs, navItems, sectionId, nextItem.dataset.tab, true, extra);
    });

    navList.dataset.bound = 'true';
  }

  function initTabSliders(contextEl) {
    contextEl.querySelectorAll('.tabs-with-videos__slider').forEach((slider) => {
      const nextBtn = slider.querySelector('[data-swiper-next]');
      if (slider.swiper) {
        slider.swiper.update();
        return;
      }
      new Swiper(slider, {
        slidesPerView: 1.2,
        spaceBetween: 13,
        freeMode: true,
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: nextBtn,
        },
        breakpoints: { 990: { slidesPerView: 2.2 } },
      });
    });
  }

  function initSection(config, section) {
    const wrapper = section.querySelector(config.wrapperSelector);
    if (!wrapper) return;

    const tabs = Array.from(wrapper.querySelectorAll(config.tabClass));
    const navList = wrapper.querySelector(config.navListSelector);
    if (!tabs.length || !navList) return;

    if (!wrapper.dataset.ready) {
      buildNav(navList, tabs, config.navItemClass, config.type);
      wrapper.dataset.ready = 'true';
    }

    const navItems = Array.from(navList.querySelectorAll(config.navItemClass));
    const sectionId = wrapper.id;
    wireNavEvents(navList, tabs, navItems, sectionId, config.initExtra, config.navItemClass);

    const stored = activeTabs.get(sectionId);
    const defaultIndex = Math.max(0, (parseInt(wrapper.dataset.defaultIndex, 10) || 1) - 1);
    const initial =
      stored && tabs.some((t) => t.id === stored) ? stored : tabs[defaultIndex]?.id || tabs[0]?.id || null;
    if (initial) activateTab(tabs, navItems, sectionId, initial, false, config.initExtra);
  }

  function initAll() {
    tabConfigs.forEach((config) => {
      const wrappers = document.querySelectorAll(config.wrapperSelector);
      wrappers.forEach((wrapper) => {
        const section = wrapper.closest('[id^="shopify-section"]');
        if (section) initSection(config, section);
      });
    });
  }

  function handleSectionEvent(e) {
    const sectionId = e.detail?.sectionId;
    if (!sectionId) return initAll();
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!section) return;
    tabConfigs.forEach((config) => {
      if (section.querySelector(config.wrapperSelector)) initSection(config, section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();
    if (window.Shopify && window.Shopify.designMode) {
      ['load', 'select', 'reorder'].forEach((name) =>
        document.addEventListener(`shopify:section:${name}`, handleSectionEvent)
      );
      document.addEventListener('shopify:block:select', handleSectionEvent);
    }
  });
})();
